const style = getComputedStyle(document.documentElement);

export const getCssVar = (name) => style.getPropertyValue(name).trim();
export const getCssVarAsRgb = (name) => style.getPropertyValue(name).trim();
